export interface IFrontPage {
}

export class FrontPage implements IFrontPage {
}